/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as _ from 'lodash';

import template from './targeting-template-edit-form.component.html';

@Component({
  standalone: false,
  selector: 'adn-targeting-template-edit-form',
  template
})
export class TargetingTemplateEditFormComponent {
  @Input() template: any;
  @Input() teams: any[];
  @Input() yourTeams: any[];
  @Input() saving = false;

  @Output() onCancel = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<void>();

  selectTeams(): void {
    if (!this.template) {
      return;
    }
    this.template.teams = _.map(this.teams || [], 'id');
  }

  deselectTeams(): void {
    if (!this.template) {
      return;
    }
    this.template.teams = [];
  }

  onEnter(event: KeyboardEvent): void {
    event.preventDefault();
    this.onSave.emit();
  }
}
